import "./staticTicket.scss";
import {
  TicketLayoutDetailModel,
  TicketLayoutModel,
} from "../../models/ticketLayoutModel";
import logo from "../../../assets/imageIcon.svg";

export default function StaticTicket(props: {
  isRealTicket?: boolean;
  ticketLayout: TicketLayoutModel;
  backgroundImage?: string;
  logoImage?: string;
  eventName?: string;
  fullName?: string;
  id?: string;
  date?: boolean;
  description?: string;
  ticketId?: string;
  width?: string;
  withBackground?: boolean;
}) {
  function getLayoutByOrder(
    ticketLayout: TicketLayoutModel,
    orderNumber: number
  ): TicketLayoutDetailModel | undefined {
    let result;
    Object.keys(ticketLayout).forEach((e) => {
      if (ticketLayout[e as keyof TicketLayoutModel].order == orderNumber)
        result = ticketLayout[e as keyof TicketLayoutModel];
    });
    return result;
  }

  function formatDate(date: Date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 101).toString().substring(1);
    var day = (date.getDate() + 100).toString().substring(1);
    return day + "/" + month + "/" + year;
  }

  function getTextFromKey(key?: string) {
    switch (key) {
      case "eventName":
        return props.eventName;
      case "date":
        return props.date ? formatDate(new Date(Date.now())) : undefined;
      case "fullNameAndId":
        return props.fullName || props.ticketId
          ? `${props.fullName ?? ""} ${props.ticketId ?? ""}`
          : undefined;
      case "description":
        return props.description;
    }
  }

  return (
    <div
      className={props.withBackground ? "static-ticket-outer-container" : ""}
      id={props.withBackground ? props.id : undefined}
    >
      <div
        id={!props.withBackground ? props.id : undefined}
        className="static-ticket"
        style={{
          width: props.width,
        }}
      >
        <div className="static-ticket-background">
          {props.backgroundImage && (
            <img src={props.backgroundImage} width="100%" height={"100%"} />
          )}
        </div>
        <div className="static-ticket-content">
          {[...Array(3)].map((e, i) => (
            <div
              key={i}
              style={{
                color: getLayoutByOrder(props.ticketLayout, i)?.color,
                fontWeight: getLayoutByOrder(props.ticketLayout, i)?.fontWeight,
                fontSize: getLayoutByOrder(props.ticketLayout, i)
                  ?.staticFontSize,
                width: "100%",
                textAlign: "start",
              }}
            >
              {props.isRealTicket
                ? getTextFromKey(getLayoutByOrder(props.ticketLayout, i)?.key)
                : getLayoutByOrder(props.ticketLayout, i)?.hintText}
            </div>
          ))}
          <div style={{ flex: 1 }} />
          <div
            style={{
              color: getLayoutByOrder(props.ticketLayout, 3)?.color,
              fontWeight: getLayoutByOrder(props.ticketLayout, 3)?.fontWeight,
              fontSize: getLayoutByOrder(props.ticketLayout, 3)?.staticFontSize,
              width: "100%",
              textAlign: "start",
            }}
          >
            {props.isRealTicket
              ? getTextFromKey(getLayoutByOrder(props.ticketLayout, 3)?.key)
              : getLayoutByOrder(props.ticketLayout, 3)?.hintText}
          </div>
        </div>
        <div className="static-ticket-logo-container">
          <div className="static-ticket-seperator" />
          <img className="static-ticket-logo" src={props.logoImage ?? logo} />
        </div>
      </div>
    </div>
  );
}
